import {createSlice} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

interface PermissionsStateInterface {
    localSelections: { role_id: string, section_id: string, action_id: string }[];
}

function getInitialState(): PermissionsStateInterface {
    return {
        localSelections: [],
    }
}

export const PermissionsSlice = createSlice({
    name: "PermissionsSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => getInitialState(),

        setSelection: (state, action: {
            payload: { role_id: string, section_id: string, action_id: string }[]
        }) => {
            state.localSelections = action.payload;
        },

        clearSelection: (state, action: {
            payload: { role_id: string, section_id: string, action_id: string }
        }) => {
            state.localSelections = state.localSelections.filter(selection => String(selection.role_id) !== String(action.payload.role_id) || selection.section_id !== action.payload.section_id || selection.action_id !== action.payload.action_id);
        },
    }
})

export const {
    reset,
    setSelection,
    clearSelection,
} = PermissionsSlice.actions;

export const getSelectorForLocalSelections = (state: RootState) => state.permissions.localSelections;

export const PermissionsReducer = PermissionsSlice.reducer;
